import { render, staticRenderFns } from "./IconShare.vue?vue&type=template&id=0adbe669"
import script from "./IconShare.vue?vue&type=script&lang=js"
export * from "./IconShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports